export const TitleWithTooltip = {
    name: 'TitleWithTooltip',
    props: {
        showToolTip: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
    },
    render() {
        const titleProps = {
            visible: this.showToolTip,
            title: this.title,
            content: (
                <p ref="title" class="widget-error-panel__widget-title">
                    {this.title}
                </p>
            ),
        };
        return this.wrapTooltip(titleProps);
    },
};
